import { render } from "./_id.vue?vue&type=template&id=c0124f46&scoped=true&ts=true"
import script from "./_id.vue?vue&type=script&lang=ts"
export * from "./_id.vue?vue&type=script&lang=ts"

import "./_id.vue?vue&type=style&index=0&id=c0124f46&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0124f46"]])

export default __exports__